import React from 'react';
import { Newsletter } from 'components/newsletter/Newsletter';

export const Component = () => {
  return <Newsletter isSlice tagline="News" title="Subscribe to the newsletter" />;
};
